import { render, staticRenderFns } from "./waste-detection.vue?vue&type=template&id=22fbf8c4&scoped=true&"
import script from "./waste-detection.vue?vue&type=script&lang=ts&"
export * from "./waste-detection.vue?vue&type=script&lang=ts&"
import style0 from "./waste-detection.vue?vue&type=style&index=0&id=22fbf8c4&prod&lang=scss&scoped=true&"
import style1 from "./waste-detection.vue?vue&type=style&index=1&id=22fbf8c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbf8c4",
  null
  
)

export default component.exports